export const identifyCandidate = async (currentUser, candidateProfile) => {
  const { currentState, slug } = candidateProfile

  if (currentState === 'ONBOARDING') {
    return
  }

  analytics.identify(currentUser.id, {
    name: currentUser.name,
    email: currentUser.email,
    createdAt: currentUser.created_at,
    state: currentState,
    slug,
    traits: {
      user_type: 'candidate',
    },
    user_type: 'candidate',
  })
}
